var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"mr-4",attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('print-clicked')}}},[_vm._v(" Print ")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('legend-clicked')}}},[_vm._v(" Legend ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }